export default __webpack_public_path__ + "fonts/whats-img3.svg";